import { render, staticRenderFns } from "./TabContainer.vue?vue&type=template&id=67b1bc0c&"
import script from "./TabContainer.vue?vue&type=script&lang=ts&"
export * from "./TabContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports